export default __webpack_public_path__ + "static/media/new-upload-not-selected.bd6658b4.svg";